import React from "react";
import styled from "styled-components";
import { breakpoints, colors } from "../../../../theme";
import { POINTER_HOVER_MEDIA } from "../../../styles/pointer-hover";
import { STATIC_PFP_URL } from "../../../utils/constants/projects";
import VettedBy from "../vetted-by";

// Same-origin copy in /static so the download attribute works.
// CDN original: https://images.clickforcode.workers.dev/parmeet_senior-frontend.pdf
const RESUME_URL = "/parmeet_senior-frontend.pdf";
const RESUME_FILENAME = "parmeet_senior-frontend.pdf";

//styles
export const AvatarWrapper = styled.figure`
  position: relative;
  display: flex;
  background: #ffffff;
  max-width: 640px;
  margin: 0 auto;
  width: 100%;
  z-index: 0;

  @media (min-width: 1024px) {
    margin-bottom: 0.75rem;
  }
`;

export const AvatarClip = styled.div`
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  z-index: 20;
`;

export const AvatarImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
`;

export const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  margin: 1rem auto 0;
  padding: 0.875rem 1.25rem;

  background: transparent;
  color: ${colors.linkHover.dark};
  text-decoration: none;

  font-size: 1rem;
  font-weight: 500;

  border: 1px solid ${colors.linkHover.dark};
  border-radius: 0.5rem;

  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease, font-weight 0.15s ease;

  @media ${POINTER_HOVER_MEDIA} {
    &:hover {
      background-color: ${colors.accentLight};
      border-color: ${colors.linkHover.light};
      color: ${colors.linkHover.dark};
      font-weight: 600;
    }
  }

  &:active {
    background-color: ${colors.accent};
  }

  &:focus-visible {
    outline: 2px solid
      color-mix(in srgb, ${colors.linkHover.light} 50%, transparent);
    outline-offset: 2px;
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    margin-inline: 0;
  }

  svg {
    height: 22px;
    width: auto;
  }
`;

export default function Sidebar() {
  return (
    <>
      <AvatarWrapper>
        <AvatarClip>
          <AvatarImage
            alt="Parmeet Singh, Developer in Ludhiana, Punjab, India"
            src={STATIC_PFP_URL}
            width={640}
            height={640}
          />
        </AvatarClip>
      </AvatarWrapper>

      <DownloadButton href={RESUME_URL} download={RESUME_FILENAME}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M12 3v12m0 0l4-4m-4 4l-4-4M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Download resume
      </DownloadButton>

      <VettedBy placement="sidebar" />
    </>
  );
}
